import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetProductPageContentResponsePayload } from '@cpak/adp-cpak-bff-service-models';
import { FetcherService } from './fetcher/fetcher.service';
import { LocationTypes } from '@cpak/adp-cpak-quotes-service-models';

@Injectable({
  providedIn: 'root',
})
export class GetProductService {
  constructor(private fetcher: FetcherService) {}

  public getProduct(
    productId: string,
    countryId: string,
    quoteProductId?: string,
    locationType?: LocationTypes
  ): Observable<GetProductPageContentResponsePayload | null> {
    const defaultParams = { countryIds: countryId };
    let extendedParams: typeof defaultParams & { [key: string]: string | number } = { ...defaultParams };
    if (quoteProductId) {
      extendedParams['quoteProductId'] = quoteProductId;
    }

    if (locationType) {
      extendedParams['locationType'] = locationType;
    }
    return this.fetcher.get<GetProductPageContentResponsePayload>(
      `/api/pages/catalog/products/${encodeURIComponent(productId)}`,
      extendedParams
    );
  }
}
